import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AttendancePolicyData, CommonReducerAction, setHelperText } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import InputValues from "../../../../../Component/InputValues";
import Select from "react-select";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import FloatValues from "../../../../../Component/FloatValues";



const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class WorkRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isworkrequest: true,
      attendancepolicyid: null,
      notUnique: false,
      iswfh: true,
      wfhlimit: 1,
      iswfo: false,
      wfolimit: 99,
      isoutduty: false,
      outdutylimit: 1,
      isrestrictattendancereq: false,
      restrictattendancereqlimit: null
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    this.props.ChangeLanguage("attendancepolicy,navigation");
    const { InitAttendancePolicy } = this.props;
    Object.keys(this.state).forEach((key) => {
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state[key] = InitAttendancePolicy[key] !== undefined
          ? InitAttendancePolicy[key]
          : this.state[key];
    });
    let isworkrequest;
    if (
      InitAttendancePolicy.iswfh
      || InitAttendancePolicy.iswfo
      || InitAttendancePolicy.isoutduty
    ) {
      isworkrequest = true;
    } else {
      isworkrequest = false;
    }
    this.setState({ isworkrequest });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(2, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  validateNext = () => {
    let isError = false;
    if (this.state.isworkrequest) {
      // if (!this.state.iswfh && !this.state.isoutduty) {
      //     this.showError("Please select atleast one clock in type");
      //     isError = true;
      // }
    }
    if (this.state.iswfh) {
      if (Number(this.state.wfhlimit) <= 0) {
        this.showError("Please define the limit for work from home");
        isError = true;
      }
    }

    // if (this.state.iswfo) {
    //     if (Number(this.state.wfolimit) <= 0) {
    //         this.showError("Please define the limit for work from office");
    //         isError = true;
    //     }
    // }

    if (this.state.isoutduty) {
      if (Number(this.state.outdutylimit) <= 0) {
        this.showError("Please define the limit for out duty");
        isError = true;
      }
    }
    this.props.StepError(2, isError);

    if (isError) return false;
    this.props.click();
  };

  showError = (error) => {
    this.props.enqueueSnackbar(error, { variant: "error" });
  };

  handleChange(name, max, event) {
    switch (name) {
      case "isworkrequest": {
        this.setState({ isworkrequest: max }, () => {
          !this.state.isworkrequest
            ? this.ClearAll()
            : this.setState({ iswfh: true, wfhlimit: 3 }, () => {
                this.UpdateReducer();
              });
        });
        break;
      } case "isrestrictattendancereq": {
        this.setState({ isrestrictattendancereq: max }, () => {
          !this.state.isrestrictattendancereq
              ? this.setState({restrictattendancereqlimit: null}, () => {
             // this.ClearAll();
             this.UpdateReducer();
            }) 
            : this.setState({  restrictattendancereqlimit: 0 }, () => {
                this.UpdateReducer();
              });
        });
        break;
      }
      case "WorkFromHome":
        {
          let wfhlimit;
          max ? (wfhlimit = this.state.wfhlimit) : (wfhlimit = 0);
          this.setState({ iswfh: max, wfhlimit }, () => this.UpdateReducer());
        }
        break;
      // case "WorkFromOffice": {
      //     let wfolimit;
      //     max ? wfolimit = this.state.wfolimit : wfolimit = 0
      //     this.setState({ iswfo: max, wfolimit }, () => this.UpdateReducer())
      // }
      //     break;
      case "OutDuty": {
        let outdutylimit;
        max ? (outdutylimit = this.state.outdutylimit) : (outdutylimit = 0);
        this.setState({ isoutduty: max, outdutylimit }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "wfhlimit": {
        const isnumbers = /^[0-9]+$/;
        if (event.target.value.match(isnumbers)) {
          let wfhlimit;
          if (
            Number(event.target.value) > Number(max)
            || Number(event.target.value) < 0
            || Number.isNaN(event.target.value)
          ) {
            wfhlimit = this.state.wfhlimit;
          } else wfhlimit = Number(event.target.value);
          this.setState({ wfhlimit }, () => this.UpdateReducer());
        }
        break;
      }  case "restrictattendancereqlimit": {
        const isnumbers = /^[0-9]+$/;
        if (event.target.value.match(isnumbers)) {
          let restrictattendancereqlimit;
          if (
            Number(event.target.value) > Number(max)
            || Number(event.target.value) < 0
            || Number.isNaN(event.target.value)
          ) {
            restrictattendancereqlimit = this.state.restrictattendancereqlimit;
          } else restrictattendancereqlimit = Number(event.target.value);
          this.setState({ restrictattendancereqlimit }, () => this.UpdateReducer());
        }
        break;
      }
      // case "wfolimit": {
      //     var numbers = /^[0-9]+$/;
      //     if (event.target.value.match(numbers)) {
      //         let wfolimit;
      //         if (Number(event.target.value) > Number(max) || Number(event.target.value) < 0 || Number.isNaN(event.target.value))
      //             wfolimit = this.state.wfolimit
      //         else
      //             wfolimit = Number(event.target.value);
      //         this.setState({ wfolimit }, () => this.UpdateReducer())
      //     }
      // }
      //     break;
      case "outdutylimit": {
        const isnumbers = /^[0-9]+$/;
        if (event.target.value.match(isnumbers)) {
          let outdutylimit;
          if (
            Number(event.target.value) > Number(max)
            || Number(event.target.value) < 0
            || Number.isNaN(event.target.value)
          ) {
            outdutylimit = this.state.outdutylimit;
          } else outdutylimit = Number(event.target.value);
          this.setState({ outdutylimit }, () => this.UpdateReducer());
        }
        break;
      }
      default:
        break;
    }
  }

  RenderLeaveDeduct = () => (
    <span>
      <FormattedMessage
        id="LbChooseleavetype"
        defaultMessage="Choose leave type "
      />
      <span className="width260 inline-block margin-left-8">
        <Select
          autofocus
          placeholder="Select"
          options={this.state.LeaveType}
          getOptionLabel={(option) => option.displayname}
          getOptionValue={(option) => option.displayvalue}
          onChange={this.handleChange.bind(this, "absenteeismleaveid")}
          value={this.state.absenteeismleaveid}
        />
      </span>
      <br />
      <br />

      <FormattedMessage
        id="LbNumberLeaveDeduct"
        defaultMessage="Number of requests to restrict"
      />
      <FloatValues
        width="100px"
        min="0"
        max="31"
        field="absenteeismleavecount"
        step="0.25"
        onChange={this.handleChange.bind(this, "absenteeismleavecount", 31)}
        value={this.state.absenteeismleavecount}
        defaultvalue={this.state.absenteeismleavecount}
        disabled={!this.state.absenteeismleaveid}
        title={"Value must be greater than 0"}
      />
    
    </span>
  );

  ClearAll = () => {
    this.setState(
      {
        iswfh: null,
        wfhlimit: 3,
        iswfo: null,
        wfolimit: 99,
        isoutduty: null,
        outdutylimit: 3,
        restrictattendancereqlimit: null,
      },
      () => this.UpdateReducer(),
    );
  };

  UpdateReducer = () => {
    this.props.AttendancePolicyData({
      ...this.props.InitAttendancePolicy,
      ...{
        isworkrequest: this.state.isworkrequest,
        iswfh: this.state.iswfh,
        wfhlimit: this.state.wfhlimit,
        iswfo: this.state.iswfo,
        wfolimit: this.state.wfolimit,
        isoutduty: this.state.isoutduty,
        outdutylimit: this.state.outdutylimit,
        isrestrictattendancereq: this.state.isrestrictattendancereq,
        restrictattendancereqlimit: this.state.restrictattendancereqlimit,
      },
    });
  };

  render() {
    const language = this.props.Language.attendancepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content">
            <p className="input-form-label"></p>
            <div className="padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head ">
                <FormattedMessage
                  id="__Lbisworkrequest"
                  defaultMessage="Define Work From Home (WFH) or Out Duty (OD) requests"
                />
              </p>
              {/* <div className="depedent-select-list"
                                onClick={() => this.handleChange('isworkrequest', true)}
                                aria-expanded={this.state.isworkrequest}>
                                <span><FormattedMessage id="LbYes" defaultMessage="Yes" /></span>
                                {this.state.isworkrequest ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected"></span>}
                            </div> */}
              <div className="et-level2" style={{ margin: 0, width: "100%" }}>
                <Collapse
                  in={this.state.isworkrequest}
                  timeout={2}
                  unmountOnExit
                  className="padding20 overflow-initial"
                >
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="__LbClockInType"
                      defaultMessage="Defining request limit is optional"
                    />
                  </p>
                  <div>
                    <div
                      className="depedent-select-list"
                      aria-expanded={this.state.iswfh}
                    >
                      <span
                        onClick={() =>
                          this.handleChange("WorkFromHome", !this.state.iswfh)
                        }
                      >
                        <FormattedMessage
                          id="LbWorkFromHome"
                          defaultMessage="Work From Home"
                        />
                      </span>
                      {this.state.iswfh ? (
                        <span
                          onClick={() =>
                            this.handleChange("WorkFromHome", !this.state.iswfh)
                          }
                          className="floatright selected-box"
                        >
                          {" "}
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            this.handleChange("WorkFromHome", !this.state.iswfh)
                          }
                          className="not-selected-box"
                        ></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.iswfh}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <FormattedMessage
                          id="LbHowManyRequest"
                          defaultMessage="How many requests can an employee send each month?"
                        />
                        <InputValues
                          min="1"
                          max="30"
                          field="wfhlimit"
                          onChange={this.handleChange.bind(
                            this,
                            "wfhlimit",
                            30,
                          )}
                          value={this.state.wfhlimit}
                          defaultvalue={this.state.wfhlimit}
                        />
                      </Collapse>
                    </div>
                  </div>

                  {/* <div>
                                        <div className="depedent-select-list"
                                            aria-expanded={this.state.iswfo}>
                                            <span onClick={() => this.handleChange('WorkFromOffice', !this.state.iswfo)}><FormattedMessage id="LbWorkFromOffice" defaultMessage="Work From Office" /></span>
                                            {this.state.iswfo ? <span onClick={() => this.handleChange('WorkFromOffice', !this.state.iswfo)} className="floatright selected-box"> <svg width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                            </svg></span> : <span onClick={() => this.handleChange('WorkFromOffice', !this.state.iswfo)} className="not-selected-box"></span>}
                                        </div>
                                        <div className="et-level3">
                                            <Collapse in={this.state.iswfo} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                                <FormattedMessage id="LbHowManyRequest" defaultMessage="How many requests can an employee send each month?" />
                                                <InputValues
                                                    min="0"
                                                    max="30"
                                                    field="wfolimit"
                                                    onChange={this.handleChange.bind(this, "wfolimit", 30)}
                                                    value={this.state.wfolimit}
                                                    defaultvalue={this.state.wfolimit}
                                                />

                                            </Collapse>
                                        </div>
                                    </div> */}

                  <div>
                    <div
                      className="depedent-select-list"
                      aria-expanded={this.state.isoutduty}
                    >
                      <span
                        onClick={() =>
                          this.handleChange("OutDuty", !this.state.isoutduty)
                        }
                      >
                        <FormattedMessage
                          id="LbOutDuty"
                          defaultMessage="Out Duty"
                        />
                      </span>
                      {this.state.isoutduty ? (
                        <span
                          onClick={() =>
                            this.handleChange("OutDuty", !this.state.isoutduty)
                          }
                          className="floatright selected-box"
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            this.handleChange("OutDuty", !this.state.isoutduty)
                          }
                          className="not-selected-box"
                        ></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.isoutduty}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <FormattedMessage
                          id="LbHowManyRequest"
                          defaultMessage="How many requests can an employee send each month?"
                        />
                        <InputValues
                          min="1"
                          max="30"
                          field="outdutylimit"
                          onChange={this.handleChange.bind(
                            this,
                            "outdutylimit",
                            30,
                          )}
                          value={this.state.outdutylimit}
                          defaultvalue={this.state.outdutylimit}
                        />
                      </Collapse>
                    </div>
                  </div>
                </Collapse>
              </div>
              {/*
                            <div className="depedent-select-list"
                                onClick={() => this.handleChange('isworkrequest', false)}
                                aria-expanded={!this.state.isworkrequest}>
                                <span><FormattedMessage id="LbNo" defaultMessage="No" /></span>
                                {!this.state.isworkrequest ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected"></span>}
                            </div> */}
            </div>
            <div className="padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <span style={{ display: "inline-block", width: "80%" }}>
                Do you wish to restrict employees to send attendance request for a month?
                </span>
              </p>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isrestrictattendancereq", true)}
                  aria-expanded={this.state.isrestrictattendancereq}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isrestrictattendancereq ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
                <div className="et-level2">
                  <Collapse
                    in={this.state.isrestrictattendancereq}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                    style={{ margin: 0, width: "89%" }}
                  >
                   
                  
                  
                    <div className="et-level3">
                   <span className="margin-left-16">Number of requests to restrict</span>
                   <InputValues
                          min="0"
                          max="30"
                          field="restrictattendancereqlimit"
                          onChange={this.handleChange.bind(
                            this,
                            "restrictattendancereqlimit",
                            30,
                          )}
                          value={this.state.restrictattendancereqlimit}
                          defaultvalue={this.state.restrictattendancereqlimit}
                        />
                    </div>
                  
                  </Collapse>
                </div>
              </div>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isrestrictattendancereq", false)}
                  aria-expanded={!this.state.isrestrictattendancereq}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {!this.state.isrestrictattendancereq ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

WorkRequest.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(WorkRequest)));
